"use client";

import { useController, type Control, type FieldValues, type Path } from "react-hook-form";
import { SwitchInput, SwitchProps as SwitchInputProps } from "../rac/switch-input";

type RHFProps<T extends FieldValues> = {
	name: Path<T>;
	control: Control<T>;
	rules?: Record<string, unknown>;
} & Omit<SwitchInputProps, "value" | "onChange" | "onBlur" | "errorMessage">;

export function SwitchField<T extends FieldValues>({ name, control, rules, ...rest }: RHFProps<T>) {
	const {
		field: { onChange, onBlur, value },
		fieldState: { error },
	} = useController({ name, control, rules });

	return <SwitchInput {...rest} isSelected={value} onChange={onChange} onBlur={onBlur} errorMessage={error?.message} />;
}
